import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import CloseButton from '@/components/modals/shared/CloseButton';

interface Props {
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

function CaptchaErrorModal({ title, isOpen, onClose }: Props) {
  if (!isOpen) {
    return null;
  }

  return (
    <Overlay onClick={onClose}>
      <Component onClick={(event) => event.stopPropagation()}>
        <CloseButton onClick={onClose} />
        <Title>{title}</Title>
      </Component>
    </Overlay>
  );
}

export default CaptchaErrorModal;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`;

const Component = styled.div`
  position: relative;
  min-width: 320px;
  max-width: 660px;
  padding: 25px 40px;
  border-radius: 10px;
  background: ${(props) => props.theme.white_1};

  ${media.mobile(css`
    min-width: auto;
    margin: 0 20px;
    padding: 20px;
  `)}
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${(props) => props.theme.black};
`;
